const Index = () => import('@/view/Index');
const SubIndex = () => import('@/view/SubIndex');
const operationLog = () => import('@/view/base/operation-log');
export default [{
  path: '/index',
  name: 'index',
  component: Index
},{
  path: '/sub-index',
  name: 'SubIndex',
  component: SubIndex
}, {
  path: '/operation-log',
  name: 'operationLog',
  component: operationLog
}];
